module.exports = __webpack_public_path__ + "media/images/bed_icon@3x-4b0eeb4e.png";